import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ToolbarItemsDirective` represent a custom toolbar items of the react Schedule.
 * It must be contained in a Schedule component(`SchduleComponent`).
 * ```tsx
 * <ScheduleComponent>
 *  <ToolbarItemsDirective>
 *   <ToolbarItemDirective name= 'Today'></ToolbarItemDirective>
 *   <ToolbarItemDirective name= 'DateRangeText'></ToolbarItemDirective>
 *   <ToolbarItemDirective prefixIcon='e-icons e-cut' text='Cut'></ToolbarItemDirective>
 *  <ToolbarItemsDirective>
 * </ScheduleComponent>
 * ```
 */
export class ToolbarItemDirective extends ComplexBase {
}
ToolbarItemDirective.moduleName = 'toolbarItem';
export class ToolbarItemsDirective extends ComplexBase {
}
ToolbarItemsDirective.propertyName = 'toolbarItems';
ToolbarItemsDirective.moduleName = 'toolbarItems';
